import React, { useState } from "react";

import img5 from "../assets/img/02-2025/5_0.png";
import img6 from "../assets/img/02-2025/6_0.png";
import img7 from "../assets/img/02-2025/7_0.png";
import img8 from "../assets/img/02-2025/8_0.png";

import sornUp from "../assets/img/icon/sorn-up.svg";

export default function Select4(border) {
  const [dataS, setDataS] = useState(null);

  return (
    <>
      <div className="mb-4">
        <div className="row justify-content-center text-start">
          <div className="col-6 col-md-3 col-lg-3">
            <button className="btn text-center" onClick={(e) => setDataS(1)}>
              <img src={img5} className="w-75 px-4" />
              <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                Objectives
              </h4>
            </button>
          </div>
          <div className="col-6 col-md-3 col-lg-3">
            <button className="btn text-center" onClick={(e) => setDataS(2)}>
              <img src={img6} className="w-75 px-4" />
              <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                Participants
              </h4>
            </button>
          </div>
          <div className="col-6 col-md-3 col-lg-3">
            <a
              href="https://drive.google.com/file/d/1bIkt_D2jRrnbwWHfMIz334CAiWqNVLVG/view?usp=sharing"
              target={"_blank"}
              className="btn text-center"
            >
              <img src={img7} className="w-75 px-4" />
              <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                Programme
              </h4>
            </a>
          </div>
          <div className="col-6 col-md-3 col-lg-3">
            <a
              href="https://drive.google.com/file/d/1I14KOXaAJpWyXNMlE3VKdOOpTnCkEfcT/view?usp=drive_link"
              target={"_blank"}
              className="btn text-center"
            >
              <img src={img8} className="w-75 px-4" />
              <h4 className="weight-700 mt-3 h4-respon" style={{}}>
                Document
              </h4>
            </a>
          </div>
        </div>
      </div>
      <div>
        <div className="d-none d-md-block">
          <div className="row text-start" style={{ marginBottom: "-20px" }}>
            <div className="col-12 col-md-3 col-lg-3 text-center">
              {dataS === 1 && (
                <img
                  src={sornUp}
                  className=""
                  style={{
                    width: "50px",
                    filter:
                      "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)",
                  }}
                />
              )}
            </div>
            <div className="col-12 col-md-3 col-lg-3 text-center">
              {dataS === 2 && (
                <img
                  src={sornUp}
                  className=""
                  style={{
                    width: "50px",
                    filter:
                      "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)",
                  }}
                />
              )}
            </div>
          </div>
        </div>
        {dataS === 1 ? (
          <div
            className="p-4"
            style={{ background: "#FFDE59", borderRadius: "15px" }}
          >
            <ol>
              <li>
                Enhance understanding of net zero and carbon neutral concepts,
                with a focus on how these principles can be integrated into the
                education sector to support the achievement of these goals.
              </li>
              <li>
                Facilitate the exchange of ideas, successful strategies and case
                studies on how schools and educational institutions have adopted
                net-zero and carbon-neutral policies and practices.
              </li>
              <li>
                Encourage a sustainability-oriented mindset and values such as
                Moderation, Prudence and Reasonableness with a focus on the
                ethical and long-term implications of achieving net-zero and
                carbon-neutral goals in education.
              </li>
              <li>
                Create a supportive community of educators for long-term
                alliance in sustainability through education.
              </li>
            </ol>
          </div>
        ) : dataS === 2 ? (
          <div
            className="p-4"
            style={{ background: "#FFDE59", borderRadius: "15px" }}
          >
            A total of 21 Mid-level government officials from 9 SEAMEO Member
            Countries were nominated by the Ministries of Education of SEAMEO
            Member Countries. <br />
            <br />
            Each Ministry of Education of the SEAMEO Member Country nominated
            two delegates who were involved in both policy and practice related
            to sustainable development in general, and specifically to net-zero
            and carbon neutrality. The first delegate was from the Education
            Ministry’s central office, and the second delegate was from a
            relevant government agency (e.g. natural resources, energy,
            industry, agriculture) and from the Ministry of Education.
          </div>
        ) : null}
      </div>
    </>
  );
}
